import z from 'zod'

import {
  accountSchema,
  baseTransactionSchema,
  chainIdSchema,
} from '~/components/smart-accounts/schemas'

export const claimSchema = baseTransactionSchema.and(
  z.object({
    account: accountSchema,
    chainId: chainIdSchema,
  }),
)

export type ClaimFormValues = z.input<typeof claimSchema>
